/* eslint-disable no-unused-expressions */

import { Table } from "antd";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { base_url } from "../../../base_urls";
import moment from "moment";

const Holidays = ({ holidaysData }) => {
  // const [users, setUsers] = useState([]);
  // {//console.log("holidaysDataholidaysData", holidaysData)}

  // useEffect(() => {
  //   axios.get(base_url + "/api/holiday.json").then((res) => setUsers(res.data));
  // }, []);

  // const userElements = users?.map((user, index) => ({
  //   key: index,
  //   id: user.id,
  //   Title: user.Title,
  //   HolidayDate: user.HolidayDate,
  //   Day: user.Day,
  // }));

  const columns = [
    {
      title: "Id",
      dataIndex: "ID",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.ID - b.ID,
    },
    {
      title: "Title",
      dataIndex: "TITLE",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.TITLE.length - b.TITLE.length,
    },
    {
      title: "HolidayDate",
      dataIndex: "HOLIDAY_DATE",
      render: (text) => <span>{moment(text).format("YYYY-MM-DD")}</span>,
      sorter: (a, b) => new Date(a.HOLIDAY_DATE) - new Date(b.HOLIDAY_DATE),
    },
    {
      title: "Day",
      dataIndex: "DAY",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.DAY.length - b.DAY.length,
    },
    // {
    //   title: "Action",
    //   render: () => (
    //     <div className="dropdown dropdown-action ">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_holiday"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //         >
    //           <i className="fa-regular fa-trash-can m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Holidays"
            title="Dashboard"
            subtitle="Holidays"
            modal="#add_holiday"
            // name="Add Holiday"
          />

          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={holidaysData?.length > 0 ? holidaysData : []}
                  className="table-striped"
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <AddHoliday />
      <DeleteModal Name="Delete Holiday" />
    </>
  );
};

export default Holidays;
